var _symbol, _symbol2, _rect, _use, _use2, _use3, _use4, _use5, _use6, _use7, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "card",
    face: "TC",
    width: "10em",
    preserveAspectRatio: "none",
    viewBox: "-120 -168 240 336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "SCT",
    viewBox: "-600 -600 1200 1200",
    preserveAspectRatio: "xMinYMid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 150C35 385 85 400 130 500L-130 500C-85 400 -35 385 -30 150A10 10 0 0 0 -50 150A210 210 0 1 1 -124 -51A10 10 0 0 0 -110 -65A230 230 0 1 1 110 -65A10 10 0 0 0 124 -51A210 210 0 1 1 50 150A10 10 0 0 0 30 150Z",
    fill: "black"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "VCT",
    viewBox: "-500 -500 1000 1000",
    preserveAspectRatio: "xMinYMid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-260 430L-260 -430M-50 0L-50 -310A150 150 0 0 1 250 -310L250 310A150 150 0 0 1 -50 310Z",
    stroke: "black",
    strokeWidth: 80,
    strokeLinecap: "square",
    strokeMiterlimit: 1.5,
    fill: "none"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 239,
    height: 335,
    x: -119.5,
    y: -167.5,
    rx: 12,
    ry: 12,
    fill: "white",
    stroke: "black"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#VCT",
    height: 32,
    x: -114.4,
    y: -156
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SCT",
    height: 26.769,
    x: -111.784,
    y: -119
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SCT",
    height: 70,
    x: -87.501,
    y: -135.588
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SCT",
    height: 70,
    x: 17.501,
    y: -135.588
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SCT",
    height: 70,
    x: -87.501,
    y: -68.529
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SCT",
    height: 70,
    x: 17.501,
    y: -68.529
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SCT",
    height: 70,
    x: -35,
    y: -102.058
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#VCT",
    height: 32,
    x: -114.4,
    y: -156
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SCT",
    height: 26.769,
    x: -111.784,
    y: -119
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SCT",
    height: 70,
    x: -87.501,
    y: -135.588
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SCT",
    height: 70,
    x: 17.501,
    y: -135.588
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SCT",
    height: 70,
    x: -87.501,
    y: -68.529
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SCT",
    height: 70,
    x: 17.501,
    y: -68.529
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SCT",
    height: 70,
    x: -35,
    y: -102.058
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTc);
export default __webpack_public_path__ + "static/media/tc.ef3d021d.svg";
export { ForwardRef as ReactComponent };